import _ from 'underscore';
import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Input } from '@bingads-webui-react/primitive-validation';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getWebsiteInputStyles as getStyles } from './styles';

import { websiteValidationErrors } from './consts';

export const WebsiteInput = (props) => {
  const {
    website, setWebsite, alwaysShowError, style,
  } = props;

  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);

  const onWebsiteChange = useCallback(({ target: { value } }) => {
    setWebsite(value);
  }, [setWebsite]);

  const handleWebsiteError = useCallback((errors) => {
    const errorStrings = _.map(
      errors,
      (oldError, key) => (
        _.has(websiteValidationErrors, key) ?
          i18n.getString(websiteValidationErrors[key]) : oldError)
    );
    return _.isEmpty(errorStrings) ? [] : [_.last(errorStrings)];
  }, [i18n]);


  return (
    <div className={classNames('website-input', classes.websiteInputContainer)}>
      <Input
        id="website-input"
        aria-labelledby="websiteLabel"
        data-clarity-unmask="true"
        style={style}
        name="website"
        value={website}
        validationProps={{
          field: 'website',
          errorProcessor: handleWebsiteError,
          alwaysShowError,
          debounce: 700,
        }}
        onChange={onWebsiteChange}
        placeholder={i18n.getString((_TL_('http://')))}
      />
    </div>
  );
};

WebsiteInput.propTypes = {
  website: PropTypes.string,
  setWebsite: PropTypes.func.isRequired,
  alwaysShowError: PropTypes.bool,
  style: PropTypes.shape({}),
};

WebsiteInput.defaultProps = {
  website: undefined,
  alwaysShowError: false,
  style: {},
};
